import { computed, onMounted, onUnmounted, ref } from "vue";
import { isBrowser } from "@/utils/platform/index.ts";

const DEFAULT_WIDTH = 1280;

export const useBreakpoints = () => {
  if (!isBrowser()) {
    return {
      width: ref(DEFAULT_WIDTH),
      isMobile: ref(false),
    };
  }
  const windowWidth = ref(window.innerWidth);

  const onWidthChange = () => {
    windowWidth.value = window.innerWidth;
  };

  onMounted(() => {
    window.addEventListener("resize", onWidthChange);
  });

  onUnmounted(() => {
    window.removeEventListener("resize", onWidthChange);
  });

  const width = computed(() => windowWidth.value);

  const isMobile = computed(() => windowWidth.value < 768);

  return { width, isMobile };
};
